import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../base-modal/base-modal.component";
import {ItemPasteProgressDialogData} from "./types/item-paste-progress-modal.types";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {
  FileProgressBarStatusComponent
} from "../../../../shared/components/ui/file-progress-bar-status/file-progress-bar-status.component";
import {AttachFileParams, UploadFileData} from "../../../types/file.types";
import {defaultFileParams} from "../../../models/default-file-params";
import {FilesService} from "../../../services/files.service";
import {FileUploadService} from "../../../services/file-upload.service";
import {ItemPasteProgressModalService} from "./services/item-paste-progress-modal.service";

@Component({
  selector: 'app-item-paste-progress-modal',
  imports: [
    BaseModalComponent,
    FileProgressBarStatusComponent
  ],
  templateUrl: './item-paste-progress-modal.component.html',
  styleUrl: './item-paste-progress-modal.component.scss'
})
export class ItemPasteProgressModalComponent extends BaseModalComponent {
  public itemPasteProgressDialogData = inject<ItemPasteProgressDialogData>(MAT_DIALOG_DATA);
  private filesService: FilesService = inject(FilesService);
  private fileUploadService: FileUploadService = inject(FileUploadService);
  private itemPasteProgressModalService: ItemPasteProgressModalService = inject(ItemPasteProgressModalService);

  public override async ngOnInit() {
    super.ngOnInit();
    await Promise.all(this.itemPasteProgressDialogData.files.map(file => this.uploadFile(file)));
  }

  private async uploadFile(selectedFile: File): Promise<void> {
    const formData = this.filesService.createFormData({
      file: selectedFile,
      fileType: 'file'
    });

    const uploadFileData: UploadFileData = {
      formData: formData,
      entityId: this.itemPasteProgressDialogData.id,
      entityFileType: this.itemPasteProgressDialogData.entityFileType
    };

    await this.fileUploadService.uploadFile(uploadFileData)
      .then((fileParams) => this.updateFiles(fileParams.id))
      .catch(() => defaultFileParams);
  }

  private async updateFiles(fileId: number): Promise<void> {
    const attachFileParams: AttachFileParams = {
      parentId: this.itemPasteProgressDialogData.id,
      fileId: fileId,
      type: this.itemPasteProgressDialogData.type
    };

    await this.itemPasteProgressModalService.attachFile(attachFileParams).finally(() => this.closeDialog('cancel'));
  }
}
